import React from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CampaignCardHolder from "../../styles/campaignCardStyle";
import { getCardThumb, getCategoryName } from "../../utils/campaignDisplay";
import CampaignBadges from "./CampaignBadges";
import CampaignUsageBar from "./CampaignUsageBar";
import CampaignBudgetBox from "./CampaignBudgetBox";
import CampaignCardActions from "./CampaignCardActions";

const formatDate = (value) => (value ? moment(value).format("DD/MM/YYYY") : "—");

const CampaignCardNew = ({
  campaign,
  state,
  statusLabel,
  viewMode = "grid",
  onDetail,
  onEdit,
  onDelete,
  onArchive,
}) => {
  const { t, i18n } = useTranslation();
  const clientName = campaign.client && campaign.client.name;
  const categoryName = getCategoryName(campaign.category, i18n.language);
  const thumb = getCardThumb(campaign);

  return (
    <CampaignCardHolder
      className={viewMode === "list" ? "campaignCard--list" : ""}
    >
      <div className="campaignCard__top">
        <CampaignBadges
          campaign={campaign}
          state={state}
          statusLabel={statusLabel}
        />
        <div className="campaignCard__edit" onClick={onEdit}>
          <Icon type="edit" />
        </div>
      </div>

      <div className="campaignCard__head">
        <div className="campaignCard__headtext">
          <h3 className="campaignCard__title" title={campaign.name}>
            {campaign.name}
          </h3>
          {clientName && (
            <p className="campaignCard__meta">
              {t("Client")}: {clientName}
            </p>
          )}
          <p className="campaignCard__meta campaignCard__meta--category">
            {t("Category")}: {categoryName || "—"}
          </p>
        </div>

        <div className="campaignCard__logo">
          <img src={thumb} alt={campaign.name} />
        </div>
      </div>

      <div className="campaignCard__dates">
        <span>
          <small>{t("Start")}:</small>
          {formatDate(campaign.start_date)}
        </span>
        <span>
          <small>{t("Finalization")}:</small>
          {formatDate(campaign.end_date)}
        </span>
      </div>

      <CampaignUsageBar campaign={campaign} />
      <CampaignBudgetBox campaign={campaign} />

      <CampaignCardActions
        onDetail={onDetail}
        onDelete={onDelete}
        onArchive={onArchive}
      />
    </CampaignCardHolder>
  );
};

export default CampaignCardNew;
